import React, { useState } from 'react';
import { db } from "../firebase.js";

import { collection, addDoc, serverTimestamp} from "firebase/firestore";

const Kanyadan = () => {
  const [formData, setFormData] = useState({
    // Initial state for your form data
    potentialDonations: '', // संभावित कन्या दान संख्या
    name: '',               // नाम
    dob: '',                // जन्म तिथि
    mobile: '',             // मोबाइल नंबर
    address: '',            // पता
    city: '',               // शहर
    block: '',              // ब्लॉक
    district: '',           // जिला
    state: '',              // राज्य
    country: '',            // देश
    pinCode: '',            // पिन कोड
  });

  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'radio' ? value : event.target.value, // Handle radio input types
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await addDoc(collection(db, 'Kanyadan'), {
        ...formData,
        timestamp: serverTimestamp(),
      });
      alert('व्यक्ति सफलतापूर्वक जोड़ा गया!');
      setFormData({
        potentialDonations: '', // संभावित कन्या दान संख्या
        name: '',               // नाम
        dob: '',                // जन्म तिथि
        mobile: '',             // मोबाइल नंबर
        address: '',            // पता
        city: '',               // शहर
        block: '',              // ब्लॉक
        district: '',           // जिला
        state: '',              // राज्य
        country: '',            // देश
        pinCode: '',            // पिन कोड
      });
    } catch (error) {
      console.error('Error saving data:', error);
      // Handle errors appropriately (e.g., display an error message)
    }
  };

  return (
    <div className="min-h-screen bg-pink-50 p-4">
      {/* Heading Section */}
      <div className="text-center py-4 md:py-6">
        <h1 className="text-3xl md:text-5xl lg:text-7xl font-extrabold text-[#991311] mb-2">कन्यादान के पुनीत कार्य में सहयोग हेतु जुड़ें</h1>
        <h2 className="text-xl md:text-2xl lg:text-4xl text-gray-700 font-bold py-5">इसके अन्तर्गत कन्यादान से संबंधित आवश्यक जानकारी का विवरण भरना</h2>
      </div>
      
      <div className="flex flex-col lg:flex-row lg:justify-end px-2 md:px-4 lg:px-8 gap-4">       
        {/* Form container */}
        <div className="w-full lg:w-2/3 bg-white p-4 md:p-6 border-2" onSubmit={handleSubmit}>
        <form className="max-w-3xl mx-auto">
  {/* Form Heading */}
  <h2 className="text-center text-lg font-semibold mb-4">कन्यादान फॉर्म</h2>
  
  <div className="grid grid-cols-1 md:grid-cols-12 gap-y-4 md:gap-x-3 md:gap-y-1">
    {/* Number of Potential Donations */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">संभावित कन्या दान संख्या</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="number" 
        placeholder="0"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="potentialDonations"
        value={formData.potentialDonations}
        onChange={handleChange}
        required
      />
    </div>

    {/* Name */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">नाम</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="text" 
        placeholder="राम ठाकुर"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
      />
    </div>

    {/* Date of Birth */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">जन्म तिथि</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="date" 
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="dob"
        value={formData.dob}
        onChange={handleChange}
        required
      />
    </div>

    {/* Mobile */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">मोबाइल नंबर</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="text" 
        placeholder="+91 555 555-1234"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="mobile"
        value={formData.mobile}
        onChange={handleChange}
        required
      />
    </div>

    {/* Address */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">पता</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="text" 
        placeholder="ग्राम/स्थान"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="address"
        value={formData.address}
        onChange={handleChange}
        required
      />
    </div>

    {/* City */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">शहर</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="text" 
        placeholder="शहर"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="city"
        value={formData.city}
        onChange={handleChange}
        required
      />
    </div>

    {/* Block */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">ब्लॉक</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="text" 
        placeholder="ब्लॉक"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="block"
        value={formData.block}
        onChange={handleChange}
        required
      />
    </div>

    {/* District */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">जिला</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="text" 
        placeholder="जिला"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="district"
        value={formData.district}
        onChange={handleChange}
        required
      />
    </div>

    {/* State */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">राज्य</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="text" 
        placeholder="राज्य"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="state"
        value={formData.state}
        onChange={handleChange}
        required
      />
    </div>

    {/* Country */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">देश</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="text" 
        placeholder="देश"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="country"
        value={formData.country}
        onChange={handleChange}
        required
      />
    </div>

    {/* PIN Code */}
    <div className="col-span-1 md:col-span-3">
      <label className="text-s">पिन कोड</label>
    </div>
    <div className="col-span-1 md:col-span-9">
      <input 
        type="text" 
        placeholder="123456"
        className="w-full border-b border-gray-300 text-gray-500 text-sm"
        name="pinCode"
        value={formData.pinCode}
        onChange={handleChange}
        required
      />
    </div>
  </div>

  {/* Submit Button */}
  <div className="pt-4">
    <button
      type="submit"
      className="w-full py-2 text-lg font-semibold text-white bg-[#991311] rounded-md"
    >
      जमा करें
    </button>
  </div>
</form>

        </div>


        {/* right side */}
        <div className="w-full lg:w-1/4 lg:pr-8 pt-4 text-[#991311] text-2xl md:text-3xl lg:text-4xl font-bold mt-2 lg:mt-5">
          <p>कन्यादान में सहभागिता करने वालों का विवरण</p>
        </div>
      </div>
    </div>
  );
};

export default Kanyadan;
